import { SxStyle } from '../../../types/style';

const contentBox: SxStyle = {
    width: '100%',
    padding: 2,
    minHeight: 'calc(100vh - 55px)'
};

const contentBoxContainer1GridItemBox: SxStyle = {
    display: 'flex',
    justifyContent: 'space-between', 
    alignItems: 'center'
};

const contentBoxContainer1GridItemBoxTypography: SxStyle = {
    fontWeight: '700'
};

const contentBoxContainer1GridItemBoxTypographyChip1: SxStyle = {
    width: '250px',
    fontWeight: 'bold',
    color: '#10B23D',
    backgroundColor: '#E3F5E8'
};

const contentBoxContainer1GridItemBoxTypographyChip2: SxStyle = {
    width: '250px',
    fontWeight: 'bold',
    color: '#CD1818',
    backgroundColor: '#F5E5E3'
};

const contentBoxContainer1GridItemBoxTypographyChip3: SxStyle = {
    width: '250px',
    fontWeight: 'bold',
    color: '#F18700',
    backgroundColor: '#F5F4E3'
};

const contentBoxContainer2Paper: SxStyle = {
    marginBottom: '32px'
};

const contentBoxContainer2PaperGridItem1Typography: SxStyle = {
    fontWeight: '700'
};

const contentBoxContainer2PaperGridItem2Box: SxStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
};

const contentBoxContainer2PaperGridItem3Box: SxStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
};

const contentBoxContainer2PaperGridItem3BoxAvatarGroup: SxStyle = {
    marginRight: '16px'
};

const contentBoxContainer2PaperGridItem4: SxStyle = {
    height: 'auto',
    width: '100%',
};

const contentBoxContainer2PaperGridItem5Typography: SxStyle = {
    fontWeight: '700'
};

const contentBoxContainer2PaperGridItem6Typography: SxStyle = {
    fontWeight: '700'
};

const contentBoxContainer2PaperGridItem7Typography: SxStyle = {
    fontWeight: '700'
};

const contentBoxContainer3GridItem: SxStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
};

const contentDescription: SxStyle = {
    mb: 2
};

// dialog
const dialogDialogTitle: SxStyle = {
    fontWeight: 700
};

export const ProjectDetailStyle = {
    contentBox,
    contentBoxContainer1GridItemBox,
    contentBoxContainer1GridItemBoxTypography,
    contentBoxContainer1GridItemBoxTypographyChip1,
    contentBoxContainer1GridItemBoxTypographyChip2,
    contentBoxContainer1GridItemBoxTypographyChip3,
    contentBoxContainer2Paper,
    contentBoxContainer2PaperGridItem1Typography,
    contentBoxContainer2PaperGridItem2Box,
    contentBoxContainer2PaperGridItem3Box,
    contentBoxContainer2PaperGridItem3BoxAvatarGroup,
    contentBoxContainer2PaperGridItem4,
    contentBoxContainer2PaperGridItem5Typography,
    contentBoxContainer2PaperGridItem6Typography,
    contentBoxContainer2PaperGridItem7Typography,
    contentBoxContainer3GridItem,
    contentDescription,
    dialogDialogTitle
};
